import { IToolTipComponentInterface } from 'app/interfaces/tooltip/tooltip.interface';
import React, { useState } from 'react';
import './ToolTipComponent.scss';

const ToolTipComponent = function init(props: IToolTipComponentInterface): React.ReactElement {
    let timeout;
    const [active, setActive] = useState(false);
    const {
        direction,
        content,
        delay,
        children
    } = props;

    function showTip(): void {
        timeout = setTimeout(() => {
            setActive(true);
        }, delay || 400);
    }

    function hideTip(): void {
        clearInterval(timeout);
        setActive(false);
    }

    return (
        <div
            className="Tooltip-Wrapper"
            // When to show the tooltip
            onMouseEnter={() => showTip()}
            onMouseLeave={() => hideTip()}
        >
            {children}
            {active && (
                <div className={`Tooltip-Tip ${direction || "top"}`}>
                    {/* Content */}
                    {content}
                </div>
            )}
        </div>
    );
};

export default ToolTipComponent;
